import React, { useState } from "react";
import { IconButton } from "@mui/material";
import whataspp from "../assets/icons/504.webp";
const SupportButton = ({ content, title }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSupportButtonBox = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="support-container">
      <ChatButton toggleSupportButtonBox={toggleSupportButtonBox} />
      {isOpen && (
        <SupportButtonBox
          content={content}
          title={title}
          closeChat={toggleSupportButtonBox}
        />
      )}
    </div>
  );
};

export default SupportButton;

const SupportButtonBox = ({ closeChat, content, title }) => {
  return (
    <div className="chatbox-container">
      <div className="chatbox-header">
        <span>{title || "Support contacts"}</span>
        <IconButton aria-label="close" onClick={closeChat}>
          <span className="material-icons">close</span>
        </IconButton>
      </div>
      <div className="chatbox-content">
        {/* Your chat content goes here */}
        <p> {content || "Welcome to support! How can we help you?"}</p>
      </div>
      {/* <div className="chatbox-footer">
          <input type="text" placeholder="Type your message..." />
          <button>Send</button>
        </div> */}
    </div>
  );
};

const ChatButton = (props) => {
  return (
    <a
      href="https://support.ippis.rw/CreateTicket"
      target="_blank"
      rel="noreferrer"
      // onClick={props.toggleSupportButtonBox}
      className="chat-button"
      style={{
        width: "140px",
        height: "30px",
        borderRadius: "8px",
        bottom: "20px",
        right: "2%",
        backgroundSize: "auto",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        transform: "scale(1)",
      }}
    >
      <div
        className="chat-button-label"
        id="chat-button-label"
        style={{
          borderRadius: "8px",
          color: "#fff",
          margin: "0 34px",
          padding: "4px 4px",
          right: "unset",
          backgroundColor: "transparent",
          boxShadow: "none",
          fontFamily: "Muli",
          fontWeight: 800,
          fontSize: "16px",
        }}
      >
        {/* <a
          style={{ color: "#ffff" }}
          href={`https://web.whatsapp.com/send?phone=0785569363&text=How%20May%20I%20help%20You?`}
          target="_blank"
        > */}
        Get support
        {/* </a> */}
      </div>
      {/* <img
        style={{
          width: "26px",
          height: "26px",
          left: "6%",
          position: "absolute",
          display: "inline",
          top: "50%",
          transform: "translateY(-50%)",
        }}
        src={whataspp}
        alt="Chat Icon"
      /> */}
      <span
        className="material-icons-outlined"
        style={{
          fontSize: "12x",
          left: "6%",
          position: "absolute",
          display: "inline",
          top: "50%",
          transform: "translateY(-50%)",
        }}
      >
        chat_bubble
      </span>
      <svg
        className="svg-whatsapp"
        style={{
          width: "26px",
          height: "26px",
          marginTop: "-13px",
          marginLeft: "-13px",
          left: "6%",
          display: "none",
        }}
        viewBox="0 0 448 512"
      >
        <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z" />
      </svg>
      <svg className="svg-close" id="svg-close">
        <path d="M13.978 12.637l-1.341 1.341L6.989 8.33l-5.648 5.648L0 12.637l5.648-5.648L0 1.341 1.341 0l5.648 5.648L12.637 0l1.341 1.341L8.33 6.989l5.648 5.648z" />
      </svg>
    </a>
  );
};
